import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../environments/environment.development";
import { constantvalues } from "../../const";
import { DtoSector } from "../../models/sector.model";

@Injectable({
    providedIn: 'root'
})

export class SectorService{
    baseURL: string;
    constructor(private httpClient: HttpClient) {
        this.baseURL = environment.gatewayUrl; 
    }

    getSectors(userId: number = 0){
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.CRUD_SECTOR}/${userId}`);
    }

    createSector(sector: DtoSector){
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.CRUD_SECTOR}`, sector);
    }

    updateSector(sector: DtoSector){
        return this.httpClient.put(`${this.baseURL}${constantvalues.API_URL.CRUD_SECTOR}`, sector);
    }
}